// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qnJ4","right":"styles_right__2i2F8"};